import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useHistory }  from 'react-router-dom'
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import UIUtils from "utils/UIUtils";
import paramStore from "common/page/store/ParamStore";
function ContentsContainer() {
  	const location = useLocation();
  	const receivedData = paramStore.getParam("adm6713");
	const history = useHistory();
	
	const [BIZ_NO_DISP,	SetBIZ_NO_DISP] = useState('');
	const [BIZ_NM,	SetBIZ_NM] = useState('');
	const [BANK_NM,	SetBANK_NM] = useState('');
	const [FIRM_NM,	SetFIRM_NM] = useState('')
	const [FIRM_CD,	SetFIRM_CD] = useState('')
	const [VAN_GB_NM,	SetVAN_GB_NM] = useState('')
	const [SND_ID,	SetSND_ID] = useState('');
	const [RCV_ID,	SetRCV_ID] = useState('');
	const [BIZ_NO,	SetBIZ_NO] = useState('');
	const [BANK_CD,	SetBANK_CD] = useState('');
	const [VAN_GB,	SetVAN_GB] = useState('');

	const [P_BIZ_NO_DISP,	SetP_BIZ_NO_DISP] = useState('');
	const [P_BIZ_NO,	SetP_BIZ_NO] = useState('');	
	const [P_BIZ_NM,	SetP_BIZ_NM] = useState('');
	const [P_FIRM_NM,	SetP_FIRM_NM] = useState('');
	const [P_SND_ID,	SetP_SND_ID] = useState('');
	const [P_RCV_ID,	SetP_RCV_ID] = useState('');
	
    async function onClickList(event) {
    	event.preventDefault();		
	    let dataToSend = {};
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	    	pathname: 'adm6710',
	    	state: { data: dataToSend }
	    });

    };	
	
	React.useEffect(() => {
        SetBIZ_NO_DISP(receivedData.vBIZ_NO_DISP);
        SetBIZ_NM(receivedData.vBIZ_NM);
        SetBANK_NM(receivedData.vBANK_NM);
        SetFIRM_NM(receivedData.vFIRM_NM);
        SetFIRM_CD(receivedData.vFIRM_CD);
        SetVAN_GB_NM(receivedData.vVAN_GB_NM);
        SetSND_ID(receivedData.vSND_ID);
        SetRCV_ID(receivedData.vRCV_ID);
        SetBIZ_NO(receivedData.vBIZ_NO);
        SetBANK_CD(receivedData.vBANK_CD);
        SetVAN_GB(receivedData.vVAN_GB);
        
        SetP_BIZ_NO_DISP(receivedData.vBIZ_NO_DISP);
		SetP_BIZ_NO(receivedData.vBIZ_NO);        
     	SetP_BIZ_NM(receivedData.vBIZ_NM);
     	SetP_FIRM_NM(receivedData.vFIRM_NM);
     	SetP_SND_ID(receivedData.vSND_ID);
     	SetP_RCV_ID(receivedData.vRCV_ID);
     	
    },[])	

    async function onClickCancel(event) {
    	event.preventDefault();			
		var vBANK_NM = BANK_NM;
		var vFIRM_CD = FIRM_CD;
		var vVAN_GB_NM = VAN_GB_NM;
		var vBANK_CD = BANK_CD;
		var vVAN_GB = VAN_GB;

		var vBIZ_NO_DISP = P_BIZ_NO_DISP;
		var vBIZ_NM = P_BIZ_NM;
		var vBIZ_NO = P_BIZ_NO;
		var vFIRM_NM = P_FIRM_NM;
		var vSND_ID = P_SND_ID;
		var vRCV_ID = P_RCV_ID;
		
	    let dataToSend = {vBIZ_NO_DISP, vBIZ_NM, vBANK_NM, vFIRM_NM, vFIRM_CD, vVAN_GB_NM, vSND_ID, vRCV_ID, vBIZ_NO, vBANK_CD, vVAN_GB};
	    paramStore.setParam("adm6713", dataToSend);
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: 'adm6713',
	      state: { data: dataToSend }
	    });

    };
    
    async function onAfterSave(event) {
    	event.preventDefault();

		var vBANK_NM = BANK_NM;
		var vFIRM_CD = FIRM_CD;
		var vVAN_GB_NM = VAN_GB_NM;
		var vBANK_CD = BANK_CD;
		var vVAN_GB = VAN_GB;

		if( BIZ_NO.length === 10){
			var vBIZ_NO_DISP = BIZ_NO.substring(0, 3) + '-' + BIZ_NO.substring(3, 5) + '-' + BIZ_NO.substring(5);
		} else {
			var vBIZ_NO_DISP = BIZ_NO;
		}
		
		var vBIZ_NM = BIZ_NM;
		var vBIZ_NO = BIZ_NO;
		var vFIRM_NM = FIRM_NM;
		var vSND_ID = SND_ID;
		var vRCV_ID = RCV_ID;
		
	    let dataToSend = {vBIZ_NO_DISP, vBIZ_NM, vBANK_NM, vFIRM_NM, vFIRM_CD, vVAN_GB_NM, vSND_ID, vRCV_ID, vBIZ_NO, vBANK_CD, vVAN_GB};
	    paramStore.setParam("adm6713", dataToSend);
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: 'adm6713',
	      state: { data: dataToSend }
	    });

    };    
        	
    async function onClickSave(event) {
		if(await UIUtils.confirm('수정하시겠습니까?')){
	        const response:any = await CommonUtil.execute({
	            url:"adm_6712_u001",
	            data: {
					"BIZ_NO": BIZ_NO,
					"BIZ_NM" : BIZ_NM,
					"FIRM_NM" : FIRM_NM,
					"SND_ID" : SND_ID,
					"RCV_ID" : RCV_ID,							
					"BANK_CD" : BANK_CD,
					"VAN_GB" : VAN_GB,
					"FIRM_CD" : FIRM_CD,	
				}
	        })
			.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then();
	            onAfterSave(event);
			}).catch((error) => {
		    	CommonUtil.showAxiosError(error);
		    	return;
	       	});
	       	
		}	       		  

    };   
            	
	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">시스템관리</Link></li>
					<li><Link to="#">펌뱅킹관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">펌뱅킹정보 수정</h1>
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">사업자번호</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w375'} value={BIZ_NO} placeholder={''} valueChanged={(value) => SetBIZ_NO(value)}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">사업장</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={BIZ_NM} placeholder={''} valueChanged={(value) => SetBIZ_NM(value)}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">펌뱅킹 별칭</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w100p'} value={FIRM_NM} placeholder={''} valueChanged={(value) => SetFIRM_NM(value)}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">은행</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w100p'} value={BANK_NM} placeholder={''} attrs={{ readOnly: true }}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">VAN구분</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w100p'} value={VAN_GB_NM} placeholder={''} attrs={{ readOnly: true }}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">기관코드</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w375'} value={FIRM_CD} placeholder={''} attrs={{ readOnly: true }}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">송신 아이디</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'} value={SND_ID} placeholder={''} valueChanged={(value) => SetSND_ID(value)}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">수신 아이디</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'} value={RCV_ID} placeholder={''} valueChanged={(value) => SetRCV_ID(value)}/>
								</div>
							</div>
						</div> 
					</form>
					<div className="hz-root hz-right hz-gap5">
						<Button color="gray-o" size="sm" onClick={onClickCancel}>취소</Button>
						<Button color="pri-o" size="sm" onClick={onClickSave}>저장</Button>
						<Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
					</div>								
				</main>

			</div>
		</PageContainer>
	);
}
export default ContentsContainer;